module.exports = __webpack_public_path__ + "step2.8f1724f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/old steps/step2.png
// module id = Sp97
// module chunks = 0